import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentSessionId } from '../slice/selectors';
import { SENDER_TYPES, SESSION_TYPES } from '../slice/constants';
import { useChatSlice } from '../slice';
import { useEventSource } from './useEventSource';
import { portalActions } from '../../../layouts/MainLayout/slice';

const schema = yup.object().shape({
  message: yup.string().required('Message is required'),
});

export default function useChatFormhandler() {
  const currentSessionId = useSelector(selectCurrentSessionId);
  const dispatch = useDispatch();
  const { actions } = useChatSlice();
  const { sendUserQuerry, data, open } = useEventSource();
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { isDirty },
  } = useForm({
    defaultValues: {
      message: '',
    },
    mode: 'onChange',
    reValidateMode: 'onChange',
    criteriaMode: 'all',
    shouldUnregister: false,
    shouldUseNativeValidation: false,
    resolver: yupResolver(schema),
  });

  const toggleToChat = () => {
    dispatch(portalActions.changeHistoryType(SESSION_TYPES.CHAT));
  };

  const onSubmit = (data: any) => {
    dispatch(actions.setMessage({ message: data.message, sender: SENDER_TYPES.USER, sessionId: currentSessionId || undefined }));
    sendUserQuerry(data.message);
    reset();
  };

  return { control, onSubmit: handleSubmit(onSubmit), reset, isDirty: isDirty && !open, streamingData: data, isStreaming: open, setValue, toggleToChat };
}
